import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import React, { useCallback } from 'react'
import { OfferFilterSelectButton, OfferFilterSelectButtonContent } from '../OfferFilterSelectButton'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import Switch from 'LuxKit/Switch/Switch'
import LineDoorIcon from 'LuxKit/Icons/line/LineDoorIcon'
import { stopPropagation } from 'lib/web/eventHandlerUtils'
import { useIntl } from 'react-intl'

interface Props {
  className?: string
  roomsConnected?: boolean
}

function OfferDesktopConnectingRoomsToggle({
  className,
  roomsConnected,
}: Props) {
  const intl = useIntl()
  const dispatch = useOfferPageDispatch()

  const onConnectedRoomsChange = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleConnectedRooms })
  }, [dispatch])

  return <div className={className}>
    <OfferFilterSelectButton onClick={onConnectedRoomsChange}>
      <LineDoorIcon />
      <OfferFilterSelectButtonContent>
        <BodyText variant="medium" wrap="truncate">
          {intl.formatMessage({
            id: 'xYYgwMFUet',
            defaultMessage: 'Connecting rooms',
            description: 'Label for connecting rooms toggle filter',
          })}
        </BodyText>
        <Caption variant="medium" colour="neutral-three" wrap="truncate">
          {intl.formatMessage({
            id: 'm0ZQibiem8',
            defaultMessage: 'Subject to availability',
            description: 'Disclaimer text for connecting rooms availability',
          })}
        </Caption>
      </OfferFilterSelectButtonContent>
      <Switch
        checked={roomsConnected}
        onChange={onConnectedRoomsChange}
        onClick={stopPropagation}
      />
    </OfferFilterSelectButton>
  </div>
}

type MappedProps = Pick<Props,
  | 'roomsConnected'
>

export default withOfferPageState((state): MappedProps => ({
  roomsConnected: state.isMultiRoomConnected,
}), OfferDesktopConnectingRoomsToggle)
